import { useState } from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { useGetActiveLootBoxConfigs } from "@/hooks/useGetActiveLootBoxConfigs";
import { LootBoxPlacementContext } from "@devour/client";
import GoVipRewardsInventoryDrawer from "@/components/goVip/GoVipRewardsInventoryDrawer";

interface LootBoxBlockProps {
    /**
     * Optional LootBoxConfig ID from the hub page builder.
     * - When set: shows only the specified config (single-box mode)
     * - When absent: shows all active configs with HUBPAGE placement context (all-boxes mode)
     */
    lootBoxConfigId?: string;
}

export function LootBoxBlock({ lootBoxConfigId }: LootBoxBlockProps) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const [showDrawer, setShowDrawer] = useState(false);

    const {data: activeConfigsResponse} = useGetActiveLootBoxConfigs(fullToken, LootBoxPlacementContext.HUB_PAGE);
    const configs = activeConfigsResponse?.lootBoxConfigs?.filter((c) => !c.onChain) ?? [];

    // If a specific configId is set, show only that one; otherwise show all HUB_PAGE boxes
    const displayConfigs = lootBoxConfigId
        ? configs.filter((c) => c.id === lootBoxConfigId)
        : configs;

    if (!displayConfigs.length) {
        return null;
    }

    return (
        <>
            <GoVipRewardsInventoryDrawer
                show={showDrawer}
                toggle={() => setShowDrawer(false)}
            />
            <div className="lootbox-block">
                {displayConfigs.map((config) =>
                    <button
                        key={config.id}
                        className="lootbox-block_card"
                        onClick={() => setShowDrawer(true)}
                        disabled={!fullToken}
                    >
                        <img
                            src={config.image ?? `${import.meta.env.VITE_CDN_URL}/images/govip-nft-rewards-default-image.gif`}
                            alt={config.name}
                            className="lootbox-block_card_image"
                        />
                        <div className="lootbox-block_card_name">{config.name}</div>
                        {config.description &&
                            <div className="lootbox-block_card_description">{config.description}</div>
                        }
                        <div className="lootbox-block_card_cta">
                            {fullToken ? "Open Loot Box" : "Sign in to open"}
                        </div>
                    </button>)}
            </div>
        </>
    );
}
